import React, { useState, useEffect } from "react";
import axios from "axios";
import { pointTypeFilter } from "./filterData";

function GetData({ setUniData, searchKey, setResultNumber, filters }) {
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchUniData = async () => {
      setIsLoading(true); // Sorgu başladığında loading durumunu true yap

      try {
        const response = await axios.get(
          "https://sunman54.pythonanywhere.com/search=" + searchKey,
          { mode: "cors" }
        );
        response.data.sort((a, b) => b.p2022 - a.p2022);
        setUniData(response.data);
        setResultNumber(response.data.length);
      } catch (error) {
        console.error("Veri çekme hatası:", error);
      } finally {
        setIsLoading(false); // Sorgu sona erdiğinde loading durumunu false yap
      }
    };

    fetchUniData();
  }, [searchKey]);

  useEffect(() => {

    console.log(filters);

  },[filters]);

  return (
    <div>
      {isLoading && (
        <div className="loading-overlay">
          <div className="loading-spinner"></div>
        </div>
      )}
      {/* Eğer isLoading true ise loading overlay ve spinner'ı göster */}
    </div>
  );
}

export default GetData;
